module.exports = __webpack_public_path__ + "img/DTYLX_kr.fed35354.png";